<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model :model="model" :rules="validatorRules" ref="form" slot="detail">
        <a-row>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="企业" prop="corpId">
              <j-dict-select-tag
                :disabled="corpDisAbled"
                @change="corpChange"
                dictCode="`iwt-wf`.wf_consumer_corp,corp_name,id"
                placeholder="请选择企业"
                type="list"
                v-model="model.corpId"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="班组" prop="groupId">
              <j-search-select-tag :dictOptions="groupOptions" placeholder="请选择班组" v-model="model.groupId"></j-search-select-tag>
            </a-form-model-item>
          </a-col>
          <!-- <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="人员" prop="corpUserId">
              <j-dict-select-tag
                dictCode="`iwt-wf`.wf_consumer_user,nickname,id"
                placeholder="请选择人员"
                type="list"
                v-model="model.corpUserId"
              />
            </a-form-model-item>
          </a-col>-->
          <!-- <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="车辆类型" prop="vehicleType">
              <j-dict-select-tag dictCode placeholder="请选择车辆类型" type="list" v-model="model.vehicleType" />
            </a-form-model-item>
          </a-col>-->
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="最大容量(m³)" prop="capacity">
              <a-input-number placeholder="请输入最大容量(m³)" style="width: 100%" v-model="model.capacity" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="车辆型号" prop="vehicleModel">
              <a-input placeholder="请输入车辆型号" v-model="model.vehicleModel"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="车牌" prop="vehiclePlate">
              <a-input placeholder="请输入车牌" v-model="model.vehiclePlate"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="来源" prop="ownerType">
              <j-dict-select-tag
                dictCode="owner_type"
                placeholder="请选择来源"
                type="radioButton"
                v-model="model.ownerType"
              />
            </a-form-model-item>
          </a-col>

          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="所属单位" prop="ownerOrg">
              <a-input placeholder="所属单位" v-model="model.ownerOrg"></a-input>
            </a-form-model-item>
          </a-col>

          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="照片" prop="pictures">
              <j-image-upload bizPath="wfs/vehicle" isMultiple v-model="model.pictures"></j-image-upload>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="状态" prop="vehicleStatus">
              <j-dict-select-tag
                dictCode="dev_life_status"
                placeholder="请选择状态"
                type="radioButton"
                v-model="model.vehicleStatus"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="备注" prop="remark">
              <a-textarea placeholder="请输入备注" rows="4" v-model="model.remark" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'

  export default {
    name: 'WfCorpVehicleForm',
    components: {
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model: {
          ownerType: 'own',
          vehicleStatus: 'operation',
        },
        groupOptions: [],
        corpDisAbled: false,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        labelCol2: {
          xs: { span: 24 },
          sm: { span: 3 },
        },
        wrapperCol2: {
          xs: { span: 24 },
          sm: { span: 20 },
        },
        confirmLoading: false,
        validatorRules: {
          corpId: [
            { required: true, message: '请输入企业!' },
          ],
          vehiclePlate: [
            { required: true, message: '请输入车牌!' },
          ],
        },
        url: {
          add: "/wf/corpVehicle/add",
          edit: "/wf/corpVehicle/edit",
          queryById: "/wf/corpVehicle/queryById",
          corpGroupList: "/wf/corpGroup/list"
        }
      }
    },
    computed: {
      formDisabled () {
        return this.disabled
      },
    },
    created () {
      //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
    },
    methods: {
      corpChange () {
        this.getGroup();
      },
      getGroup () {
        this.groupOptions = [];
        const params = {
          pageSize: 999999,
          corpId: this.model.corpId
        };
        getAction(this.url.corpGroupList, params).then((res) => {
          if (res.success) {
            res.result.records.forEach(group => {
              this.groupOptions.push({
                value: group.id,
                text: group.groupName
              });
            });
          } else {
            this.$message.error(res.message)
          }
        })
      },
      add (given) {
        if (given?.corpId) {
          this.corpDisAbled = true;
        }
        this.edit(Object.assign({}, given, this.modelDefault));
      },
      edit (record) {
        this.corpDisAbled = !!record.corpId;
        this.model = Object.assign({}, record);
        this.getGroup();
        this.visible = true;
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if (!this.model.id) {
              httpurl += this.url.add;
              method = 'post';
            } else {
              httpurl += this.url.edit;
              method = 'put';
            }
            httpAction(httpurl, this.model, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
    }
  }
</script>